import { Link, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'next-themes';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import logoLight from '@/assets/logo-light.svg';
import logoDark from '@/assets/logo-dark.svg';

/**
 * K25: bis WP6 eine nackte Seite mit "404 / Oops!" und einem 21 px hohen
 * Textlink. Jetzt die Karte im Stil von /auth: Marke, Satz, ein Knopf.
 * Die Route liegt ausserhalb von Layout (auch fuer Abgemeldete erreichbar),
 * deshalb traegt die Karte die Marke selbst.
 */
const NotFound = () => {
  const location = useLocation();
  const { t } = useTranslation('wizard');
  const { resolvedTheme } = useTheme();

  useEffect(() => {
    console.error('404 Error: User attempted to access non-existent route:', location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <Card className="w-full max-w-md">
        <CardContent className="flex flex-col items-center gap-4 p-8 text-center">
          <img
            src={resolvedTheme === 'dark' ? logoDark : logoLight}
            alt="FeedOptimizer.AI"
            className="h-8 w-auto"
          />
          <p className="font-mono text-sm text-muted-foreground">{t('notFound.title')}</p>
          <h1 className="font-heading text-2xl font-bold">{t('notFound.message')}</h1>
          <p className="text-sm text-muted-foreground">{t('notFound.hint')}</p>
          <Button asChild className="h-11 w-full sm:w-auto">
            <Link to="/">{t('notFound.returnHome')}</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default NotFound;
